import { getSupabaseReady, supabase } from "../lib/supabaseClient";

export async function submitDemoViewLead({ email, pagePath = "/home", demoAsset = "" }) {
  const normalizedEmail = String(email || "").trim().toLowerCase();

  if (!normalizedEmail) {
    return { success: false, error: "Email is required." };
  }

  try {
    await getSupabaseReady();

    if (!supabase) {
      return {
        success: true,
        persisted: false,
        error: "Supabase is not configured for demo tracking yet.",
      };
    }

    const { error } = await supabase.from("demo_view_leads").insert([
      {
        email: normalizedEmail,
        source: "view_demo",
        page_path: pagePath,
        demo_asset: demoAsset,
      },
    ]);

    if (error) {
      return {
        success: true,
        persisted: false,
        error: error.message || "Could not save your email.",
      };
    }

    return { success: true, persisted: true };
  } catch (error) {
    return {
      success: true,
      persisted: false,
      error: error?.message || "Could not save your email.",
    };
  }
}
